import { render, staticRenderFns } from "./splitImageCompare.vue?vue&type=template&id=020f1670&lang=pug&"
import script from "./splitImageCompare.vue?vue&type=script&lang=js&"
export * from "./splitImageCompare.vue?vue&type=script&lang=js&"
import style0 from "./splitImageCompare.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports